import React from 'react'
import _ from 'lodash'
import axios from 'axios'

export class Rating extends React.Component {
    constructor(props) {
        super(props)
    }

    getStars() {
        let count = 0
        if (this.props.itemCount) {
            if (typeof this.props.itemCount === 'string') {
                let tCount = JSON.parse(this.props.itemCount)
                if (tCount.NTM) {
                    count = parseInt(tCount.NTM.charAt(0))
                } else if (tCount.stars) {
                    count = tCount.stars
                }
            } else {
                if (this.props.itemCount.get('NTM')) {
                    count = parseInt(this.props.itemCount.get('NTM').charAt(0))
                } else if (this.props.itemCount.get('stars')) {
                    count = Math.floor(this.props.itemCount.get('stars'))
                }
            }
            if (count) {
                let stars = []
                for (var i = 1; i < 6; i++) {
                    if (i > count) {
                        stars.push(<i key={i} className="icon-star"/>)
                    } else {
				    	stars.push(<i key={i} className="icon-star_solid"/>)
                    }
                }
                let label = this.props.itemLabel ? <span>{this.props.itemLabel} </span> : ''
                return <div className="rating-block">{label}{stars}</div>
            } else {
                return null
            }
        } else {
            return null
        }
    }

    getCost() {
        // TODO: Do we want a dollar icon or just use text?
        var dollars = []
        for (var i = 1; i < 6; i++) {
            if (i > this.props.itemCount) {
                dollars.push(<i key={i} className="grey-1">$</i>)
            } else {
			    	// dollars.push(<i key={i} className="grey-3">$</i>)
            }
        }
        return <div className="rating-block">{dollars}</div>
    }

    getStartingPrice() {
        if (this.props.itemCost) {
            return <div className="related-content-price"><span>from $</span>{this.props.itemCost}</div>
        } else {
            return <div/>
        }
    }

    render() {
        if (this.props.itemCount || this.props.itemCost) {
            if (this.props.type == 'stars') {
                return this.getStars()
            } else if (this.props.type == 'cost') {
                return this.getCost()
            } else if (this.props.type == 'startingPrice') {
                return this.getStartingPrice()
            } else {
                // console.log('Rating Type is required for this item')
                return <div/>
            }
        } else {
            // console.log('Rating Item Count is required for this item')
            return <div/>
        }
    }
}
